// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

export default {
  Alert: {
    close: 'Close'
  },
  Card: {
    select: 'בחירה',
    titleLinkTooltip: 'מעבר לדף',
    collapseCardTooltip: 'צמצום הכרטיס',
    expandCardTooltip: 'הרחבת הכרטיס'
  },
  CardList: {
    loadMore: 'לטעון עוד',
    notFound: 'לא נמצאו פריטים.',
    toolbarSelect: 'בחירה',
    viewCards: 'כרטיסים',
    viewTiles: 'אריחים',
    viewList: 'רשימה',
    toolbarView: 'תצוגה'
  },
  Carousel: {
    nextSlide: 'Next slide',
    previousSlide: 'Previous slide',
    viewSlide: 'View slide %%slideNumber%%'
  },
  ComboBox: {
    close: 'Close',
    open: 'Open'
  },
  ClosingConfirmation: {
    confirm: 'יציאה',
    cancel: 'חזרה',
    content: 'בטוחים שאתם רוצים לסגור ולצאת מהחלון הזה? כל השינויים שביצעתם בנתונים לא יישמרו.'
  },
  Cuttable: {
    showMore: 'להציג עוד',
    showLess: 'להציג פחות'
  },
  Dialog: {
    closeButton: 'Close',
    cancelButton: 'ביטול'
  },
  Drawer: {
    backButton: 'Back',
    closeButton: 'Close',
    hideButton: 'Hide'
  },
  DrawerProgress: {
    cancelButton: 'ביטול'
  },
  Dropdown: {
    close: 'סגירה'
  },
  Form: {
    submitButton: 'שמירה',
    applyButton: 'החלה',
    cancelButton: 'ביטול'
  },
  FormField: {
    clear: 'ניקוי',
    remove: 'הסרה',
    addMore: 'הוספת שורה לשדה',
    showDescription: 'Show description'
  },
  FormFieldPassword: {
    improvePassword: 'כדי לשפר את הסיסמה:',
    passwordTooShort: 'האריכו את הסיסמה.',
    lettersLowerCase: 'השתמשו לפחות באות קטנה אחת.',
    lettersUpperCase: 'השתמשו לפחות באות גדולה אחת.',
    numbers1: 'השתמשו לפחות בספרה אחת.',
    numbers3: 'השתמשו לפחות ב-3 מספרים.',
    specialChar1: 'השתמשו לפחות בתו מיוחד אחד (למשל: !, @, #, $, %, ^, &, *, ?, _, ~).',
    specialChar2: 'השתמשו לפחות בשני תווים מיוחדים (למשל: !, @, #, $, %, ^, &, *, ?, _, ~).',
    comboUpperAndLower: 'השתמש גם באותיות גדולות וגם באותיות קטנות.',
    comboLettersAndNumbers: 'השתמש גם במספרים וגם בתווים.',
    comboLettersNumbersSpecial: 'השתמש במספרים, בתווים ובתווים מיוחדים.',
    yourPasswordIsStrong: 'כדי להפוך אותה לעוד יותר חזקה, אתם יכולים להאריך אותה.',
    passwordStrength: 'חוזק הסיסמה הוא %%strength%%.',
    strengthVeryStrong: 'חזק מאוד',
    strengthStrong: 'חזק',
    strengthVeryWeak: 'חלש מאוד',
    strengthWeak: 'חלש',
    strengthMedium: 'בינוני',
    hidePassword: 'הסתרת הסיסמה',
    showPassword: 'הצגת הסיסמה',
    generateButton: 'יצירה',
    copyButtonHint: 'העתקת הסיסמה',
    copySuccessToast: 'הסיסמה הועתקה',
    generateButtonHint: 'יצירת סיסמה חזקה'
  },
  InPlaceEdit: {
    cancelButtonHint: 'ביטול השינויים',
    editButtonHint: 'עריכת הערך',
    okButtonHint: 'שמירת השינויים'
  },
  InputNumber: {
    decrement: 'Decrement',
    increment: 'Increment'
  },
  InputFile: {
    browseButton: 'בחירת קובץ…'
  },
  Layout: {
    openSidebar: 'Expand sidebar',
    closeSidebar: 'Collapse sidebar'
  },
  List: {
    totalRows: '%%totalRows%% פריטים סך הכול',
    toggleAllRows: 'Toggle all rows',
    toggleRow: 'Toggle row',
    selectedRows: '%%selectedRows%% מתוך %%totalRows%% פריטים נבחרו',
    all: 'כל הפריטים',
    allItemsOnPageSelected: 'כל הפריטים בדף נבחרו',
    allItemsSelected: 'כל הפריטים נבחרו',
    selectAllItems: 'בחירת כל הפריטים',
    selectAllItemsOnPage: 'בחירת כל הפריטים בדף',
    deselectAll: 'ביטול הבחירה',
    selectRow: 'Select row',
    selectAllRows: 'Select all rows'
  },
  ListActions: {
    menuButton: 'Open menu'
  },
  ListEmptyView: {
    filteredTitle: 'לא הצלחנו למצוא פריטים שתואמים למסנן',
    emptyTitle: 'נראה שאין שום דבר כאן',
    filteredDescription: 'שפרו את השאילתה או הסירו מהמסנן כמה מהקריטריונים ונסו שוב.'
  },
  ListOperation: {
    cancelButton: 'ביטול'
  },
  Panel: {
    collapse: 'Collapse',
    expand: 'Expand'
  },
  Pagination: {
    totalShort: 'מתוך %%total%%',
    itemsPerPage: 'פריטים בכל דף',
    all: 'הכול',
    total: 'דף %%current%% מתוך %%total%%'
  },
  Popover: {
    closeButton: 'Close'
  },
  ProgressDialog: {
    closeButton: 'סגירה',
    cancelButton: 'ביטול'
  },
  Section: {
    collapse: 'Collapse',
    closeButton: 'Close',
    expand: 'Expand'
  },
  Select: {
    clearButton: 'Clear',
    noOptions: 'אין אפשרויות לבחירה',
    placeholder: 'בחירה…'
  },
  SearchBar: {
    clearButton: 'Clear',
    searchButton: 'Search',
    collapseSearch: 'Hide search input',
    expandSearch: 'Show search input'
  },
  SpotPopup: {
    total: '%%current%% מתוך %%total%%'
  },
  SwitchesPanelItem: {
    showDescription: 'Show description'
  },
  Tabs: {
    closeButton: 'Close tab'
  },
  Toaster: {
    closeGroup: 'סגירת הקבוצה'
  },
  Toast: {
    closeButton: 'Close'
  }
};